import styled from 'styled-components';
import { Cog } from '@styled-icons/boxicons-regular/Cog';

export const Container = styled.div`
  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    padding: 1rem 1.5rem;
  }

  & > header {
    display: flex;
    flex-direction: column;
    margin-bottom: 0.5rem;

    & > button > span {
      display: none;
      @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
        display: unset;
      }
    }

    & > span {
      font-family: ${({ theme }) => theme.fonts.workSans};
      font-size: 1rem;
      font-weight: 400;
    }
  }
`;

export const CogIcon = styled(Cog)`
  width: 1.4rem;

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    margin-right: 0.5rem;
  }
`;

export const ContentButton = styled.div`
  display: flex;
  justify-content: flex-end;
`;
